import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromUnits from '../reducers';
import * as unitActions from '../actions/unit';
import { Unit } from '../models/unit';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NavigationStore } from '../../lib/stores/navigationStore/navigationStore';

@Component({
  selector: 'mj-settings-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div fxFlex fxLayout="column">
      <mj-unit-top-bar></mj-unit-top-bar>
      <div fxFlex fxLayout="row" class="settings">
        <div fxFlex="100">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .settings {
        display: flex;
        padding: 70px;
        background-color: #fafafa;
      }
    `,
  ],
})
export class SettingsViewComponent {
  units$: Observable<Unit[]>;

  constructor(
    private store: Store<fromUnits.State>,
    private navStore: NavigationStore,
    private translate: TranslateService
  ) {
    this.units$ = this.store.select(fromUnits.selectUnits);

    translate
      .get('settings_header_title')
      .pipe(take(1))
      .subscribe(text => {
        this.navStore.setCurrentComponent(text);
      });
  }

  initForm() {}

  selectUnit($event: { unit: Unit; refresh: boolean }) {
    if ($event.refresh) {
      this.store.dispatch(new unitActions.LoadUnit({ unit: $event.unit }));
      this.store.dispatch(
        new unitActions.LoadUnitUsers({ id: $event.unit.id })
      );
    }
  }
}
